import { Component, Input } from "@angular/core";
import { CommonChartInfoCard } from "@tylertech/tyler-api-types";
@Component({
    selector: "common-chart-info-card",
    templateUrl: "./commonchartInfoCard.tmpl.html",
    styleUrls: ["./commonChartInfoCard.component.scss"],
    standalone: false
})
export class CommonChartInfoCardComponent
{
    @Input()
    commonChartInfoCard: CommonChartInfoCard;

    get cardStyle(): Record<string, string | number>
    {
        const color = this.commonChartInfoCard.Color;
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "background-color": `rgba(${color.R},${color.G},${color.B},${1.0})`
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }
}
